<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div id="deck-list">
        <div class="deck-list-grid">
          <div
            class="deck-item"
            v-for="item in showList"
            :key="item.uuid"
            @click="goToDetail(item)"
          >
            <div class="deck-images">
              <!-- <img v-for="(img, idx) in item.images" :key="idx" :src="img" class="deck-img" /> -->
              <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.title" class="deck-img" /> -->
              <img :src="item.images?.[0]" class="deck-img" />
              <span class="deck-bg"></span>
            </div>
            <div class="deck-content">
              <div class="deck-title CH_6_Bold ells1">{{ item.title }}</div>
              <div class="deck-remark CH_7_Regular ells3">{{ item.remark }}</div>
              <!-- <div class="deck-author">
                <img class="author-avatar" :src="item.owner.avatar" :alt="item.owner.username" />
                <span class="author-name CH_7_Regular">{{ item.owner.username }}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div v-if="!expanded && deckList.length > 4" class="more-btn-box">
          <div class="more-btn" @click="openExpanded"><span class="EN_6_Regular">{{ $t('common.more') }}</span><span class="JHSicon JHS-arrow_down"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';

declare const jhsapp: any;
interface DeckItem {
  uuid: string;
  title: string;
  images: string[];
  remark: string;
  link: string;
  game_key: string;
  environment_id: string;
  environment_name: string;
  language: string;
}

const props = defineProps<{
  deckList: DeckItem[];
  title: string;
  module_ID: string;
  module_type: string;
}>();

const expanded = ref(false);

const showList = computed(() => {
  return expanded.value ? props.deckList : props.deckList.slice(0, 4);
});

const openExpanded = () => {
  checkLoginAndGo(()=>{
    expanded.value = true;
  })
}

// 跳转详情页
const goToDetail = (item: DeckItem) => {
  track('H5Landing_module_operation', {
    operation: 'click_on_link_deck',
  });

  track('lst_H5Landing_module_deck', {
    module_ID: props.module_ID,
    module_type: props.module_type,
    game_key: item.game_key,
    language: item.language,
    decks: {
      uuid: item.uuid,
      name: item.title,
      environment_id: item.environment_id,
      environment_name: item.environment_name,
    },
  });

  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else  {
        jhsapp.router(`https://www.jihuanshe.com/app/marketDeck?marketDeckUuid=${item.uuid}`);
      }
    } catch (error) {
      console.error('跳转失败:', error);
    }
  })
};
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

#deck-list {
  width: 100%;
}
.deck-list-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--padding-7);
  margin-bottom: var(--margin-7);
}

.deck-item {
  height: 92px;
  display: flex;
  padding: var(--padding-8);
  align-items: flex-start;
  gap: var(--gap-6);
  border-radius: var(--corner-4);
  background: var(--container-surface-grey);

  .deck-images {
      width: calc(47px + 3px);
      height: calc(67px + 3px);
      position: relative;
      
      .deck-img {
          // width: 100%;
          height: 100%;
          // object-fit: cover;
          position: relative;
          z-index: 1;
      }

      .deck-bg {
          position: absolute;
          content: "";
          width: 47px;
          height: 67px;
          background: var(--container-surface-gray-alpha-subtlest);
          bottom: -3px;
          right: -3px;
          border-radius: var(--corner-4);
      }
  }

  .deck-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: var(--gap-2);
      flex: 1 0 0;
      align-self: stretch;

      .deck-title {
          color: var(--on-container-text-primary);
      }

      .deck-remark {
          height: 48px;
          color: var(--on-container-text-thirdry);
      }
  }
}
</style>
